import { formNames } from '@wkda/carlead-creation-form';
import { CarleadFieldsMap } from '../carleadFieldsMap';
export function mapFromDSB(formData, questionnaireData) {
  return { ...mapFromDSBForm(formData),
    ...mapFromDSBQuestionnaire(questionnaireData)
  };
}
const DSBToSFMap = {
  [formNames.manufacturer]: selectItemId(formNames.manufacturer),
  [formNames.mainType]: selectItemId(formNames.mainType),
  [formNames.builtDate]: selectItemId(formNames.builtDate),
  [formNames.bodyType]: selectItemId(formNames.bodyType),
  [formNames.mainTypeDetail]: selectItemId(formNames.mainTypeDetail),
  [formNames.mainTypeSub]: selectItemId(formNames.mainTypeSub),
  [formNames.mileage]: selectItemId(formNames.mileage),
  [formNames.fuelType]: selectItemId(formNames.fuelType),
  [formNames.horsePower]: selectItemId(formNames.horsePower),
  [formNames.gearType]: selectItemId(formNames.gearType),
  [formNames.doorCount]: selectItemId(formNames.doorCount),
  [formNames.location]: d => {
    var _d$zipCode, _d$zipCode$selected, _d$zipCode2, _d$zipCode2$selected;

    return d !== null && d !== void 0 && (_d$zipCode = d.zipCode) !== null && _d$zipCode !== void 0 && (_d$zipCode$selected = _d$zipCode.selected) !== null && _d$zipCode$selected !== void 0 && _d$zipCode$selected.label && d !== null && d !== void 0 && (_d$zipCode2 = d.zipCode) !== null && _d$zipCode2 !== void 0 && (_d$zipCode2$selected = _d$zipCode2.selected) !== null && _d$zipCode2$selected !== void 0 && _d$zipCode2$selected.value ? {
      label: d.zipCode.selected.label,
      lat: d.zipCode.selected.value.lat,
      lng: d.zipCode.selected.value.lng
    } : null;
  },
  [formNames.email]: d => {
    var _d$email;

    return (d === null || d === void 0 ? void 0 : (_d$email = d.email) === null || _d$email === void 0 ? void 0 : _d$email.selected) || '';
  },

  [formNames.licensePlate](d) {
    var _d$licensePlate;

    return d === null || d === void 0 ? void 0 : (_d$licensePlate = d.licensePlate) === null || _d$licensePlate === void 0 ? void 0 : _d$licensePlate.value;
  }

};

function mapFromDSBForm(data) {
  return Object.keys(DSBToSFMap).reduce((acc, key) => ({ ...acc,
    [key]: DSBToSFMap[key](data)
  }), {});
}

function mapFromDSBQuestionnaire(data) {
  var _data$flexibleQuestio, _data$flexibleQuestio2, _data$flexibleQuestio3;

  return data === null || data === void 0 ? void 0 : (_data$flexibleQuestio = data.flexibleQuestionnaire) === null || _data$flexibleQuestio === void 0 ? void 0 : (_data$flexibleQuestio2 = _data$flexibleQuestio.customerSurvey) === null || _data$flexibleQuestio2 === void 0 ? void 0 : (_data$flexibleQuestio3 = _data$flexibleQuestio2.questions) === null || _data$flexibleQuestio3 === void 0 ? void 0 : _data$flexibleQuestio3.reduce((questionnaire, question) => ({ ...questionnaire,
    [question.questionId]: question.answerId
  }), {});
}

function itemIdSelector(d) {
  return (d === null || d === void 0 ? void 0 : d.selectedId) || '';
}

function selectItemId(fieldName) {
  return function _selectItemId(d) {
    var _d$stepCompoundForm;

    return itemIdSelector(d === null || d === void 0 ? void 0 : (_d$stepCompoundForm = d.stepCompoundForm) === null || _d$stepCompoundForm === void 0 ? void 0 : _d$stepCompoundForm[CarleadFieldsMap.toDSB(fieldName)]);
  };
}